var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 15C0.75 7.12994 7.12994 0.75 15 0.75C22.8701 0.75 29.25 7.12994 29.25 15C29.25 22.8701 22.8701 29.25 15 29.25C7.12994 29.25 0.75 22.8701 0.75 15Z",
    fill: "#BCBCBC",
    fillOpacity: 0.25
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 11.8333,
    r: 6.33333,
    fill: "#288B9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9067 24.9854C24.9636 25.0825 24.9459 25.2056 24.8647 25.2835C22.3044 27.7402 18.8285 29.25 15 29.25C11.1716 29.25 7.69573 27.7402 5.13542 25.2836C5.05422 25.2057 5.03652 25.0826 5.09349 24.9856C6.91641 21.8804 10.668 19.75 15.0001 19.75C19.3322 19.75 23.0837 21.8803 24.9067 24.9854Z",
    fill: "#288B9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarFilled);
export default __webpack_public_path__ + "static/media/avatarFilled.bdaabfc808e2164d1240e7be6f750208.svg";
export { ForwardRef as ReactComponent };